import React from "react";
import "./style.css";

export default function App() {
  return (
    <div style={{ padding: 40, fontSize: 24 }}>
  🚀 Version 2 — Auto deploy test
</div>  
  );
}
